<template>
  <div class="profile">
    <el-card>
      <h2>个人中心</h2>
      <el-form :model="form" label-width="100px">
        <!-- 姓名 -->
        <el-form-item label="姓名">
          <el-input v-model="form.name" />
        </el-form-item>

        <!-- 邮箱 -->
        <el-form-item label="邮箱">
          <el-input v-model="form.emaiAddress" />
        </el-form-item>

        <!-- 手机号 -->
        <el-form-item label="手机号" prop="phone" :rules="phoneRules">
          <el-input v-model="form.phone" maxlength="11" />
        </el-form-item>

        <!-- 角色 -->
        <el-form-item label="角色">
          <el-input v-model="form.role" disabled />
        </el-form-item>

        <!-- 创建日期 -->
        <el-form-item label="创建日期">
          <el-input v-model="form.createDate" disabled />
        </el-form-item>

        <!-- 保存按钮 -->
        <el-form-item>
          <el-button type="primary" @click="save">保存</el-button>
        </el-form-item>
      </el-form>

      <!-- 更改密码表单 -->
      <el-divider />
      <h3>更改密码</h3>
      <el-form :model="passwordForm" label-width="100px" ref="passwordFormRef">
        <!-- 旧密码 -->
        <el-form-item label="旧密码" prop="oldPassword" :rules="passwordRules">
          <el-input v-model="passwordForm.oldPassword" type="password" show-password />
        </el-form-item>

        <!-- 新密码 -->
        <el-form-item label="新密码" prop="newPassword" :rules="passwordRules">
          <el-input v-model="passwordForm.newPassword" type="password" show-password />
        </el-form-item>

        <!-- 确认新密码 -->
        <el-form-item label="确认新密码" prop="confirmPassword" :rules="confirmPasswordRules">
          <el-input v-model="passwordForm.confirmPassword" type="password" show-password />
        </el-form-item>

        <!-- 更改密码按钮 -->
        <el-form-item>
          <el-button type="primary" @click="changePassword">更改密码</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import axios from '@/axios'
import { ElMessage } from "element-plus";

export default {
  props: {
    userid: {
      type: Number,
      required: true
    },
    organizationID: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      // 初始化表单数据
      form: {},
      // 密码表单数据
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
      // 手机号验证规则
      phoneRules: [
        {required: true, message: '请输入手机号', trigger: 'blur'},
        {pattern: /^1[3-9]\d{9}$/, message: '请输入有效的11位手机号', trigger: 'blur'}
      ],
      // 密码验证规则
      passwordRules: [
        {required: true, message: '请输入密码', trigger: 'blur'},
        {min: 6, max: 20, message: '密码长度在6到20个字符', trigger: 'blur'},
      ],
      // 确认密码验证规则
      confirmPasswordRules: [
        {required: true, message: '请再次输入新密码', trigger: 'blur'},
        {
          validator: (rule, value, callback) => {
            if (value !== this.passwordForm.newPassword) {
              callback(new Error('两次输入的密码不一致'));
            } else {
              callback();
            }
          },
          trigger: 'blur',
        },
      ],
    };
  },
  methods: {
    // 保存用户信息
    save() {
      axios.put('/XY/profile', this.form, {params: {userid: this.userid}})
          .then(response => {
            if (response.data.success) {
              ElMessage.success("保存成功！");
            } else {
              ElMessage.error(response.data.errorMsg || "保存失败");
            }
          })
          .catch(error => {
            console.error("保存用户信息失败", error);
            ElMessage.error("保存用户信息失败");
          });
    },

    // 更改密码
    changePassword() {
      this.$refs.passwordFormRef.validate((valid) => {
        if (valid) {

          if(this.passwordForm.oldPassword === this.passwordForm.newPassword){
            ElMessage.warning("新密码不能与旧密码相同");
            return;
          }
          // 提交更改密码请求
          axios.post('/XY/changePassword', {
            userId: this.userid,
            oldPassword: this.passwordForm.oldPassword,
            newPassword: this.passwordForm.newPassword,
          })
              .then(response => {
                if (response.data.success) {
                  ElMessage.success("密码更改成功！");
                  this.passwordForm = {oldPassword: '', newPassword: '', confirmPassword: ''}; // 清空表单
                } else {
                  ElMessage.error(response.data.errorMsg || "密码更改失败");
                }
              })
              .catch(error => {
                console.error("密码更改失败", error);
                ElMessage.error("密码更改失败");
              });
        } else {
          ElMessage.warning("请正确填写表单");
        }
      });
    },
  },
  created() {
    // 从后端获取用户信息
    axios.get('/XY/profile', {params: {userid: this.userid}})
        .then(response => {
          if (response.data.success) {
            // 将数据赋值给表单
            this.form = response.data.data;
          } else {
            ElMessage.error(response.data.errorMsg || "获取用户信息失败");
          }
        })
        .catch(error => {
          console.error("获取用户信息失败", error);
          ElMessage.error("获取用户信息失败");
        });
  }
};
</script>

<style scoped>
.profile {
  padding: 20px;
}
</style>